import * as getters from './getters';

import actions from './actions';
import mutations from './mutations';

const state = () => ({
  trendingTickers: { data: [], loading: false, error: null },
  trendingGainersTickers: { data: null, loading: false, error: null },
  trendingLosersTickers: { data: null, loading: false, error: null },
});

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
